"use strict";
// let count = 0;
// export const createToken = () => Symbol(String(count++));
Object.defineProperty(exports, "__esModule", { value: true });
exports.createToken = void 0;
const ids = new Set();
const createToken = (id) => {
    if (ids.has(id))
        throw new Error(`Token '${id}' already exists!`);
    ids.add(id);
    return Symbol(id);
};
exports.createToken = createToken;
//# sourceMappingURL=support.js.map